export default __webpack_public_path__ + "static/logo_full-5e54b5b4c28af879c9ad148c165c45d3.svg";